import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForestLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 257,
	height: 100,
	fill: "none",
	viewBox: "0 0 257 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m1.214 41.88 32.649-1.237c1.02-.039 1.507-1.289.784-2.01-2.45-2.448-6.676-6.785-9.404-10.22-2.686-3.381-5.971-8.472-7.622-11.093a1.185 1.185 0 0 0-2.028.047c-1.54 2.722-4.61 8.05-7.07 11.68-2.43 3.589-6.145 8.295-8.263 10.926-.628.78-.046 1.944.954 1.907"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m23.382 28.599 32.649-1.237c1.02-.039 1.506-1.289.784-2.01-2.45-2.447-6.676-6.785-9.404-10.22-2.686-3.38-5.971-8.472-7.621-11.092a1.185 1.185 0 0 0-2.028.047c-1.54 2.722-4.61 8.051-7.07 11.68-2.43 3.59-6.145 8.295-8.263 10.926-.628.78-.046 1.945.954 1.907"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M155.976 70.046a.774.774 0 0 0-.706-.74l-2.931-.255a.773.773 0 0 0-.839.8l.212 5.603c.016.427.375.76.802.743l2.917-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m139.845 46.413 25.923-.982c1.021-.039 1.507-1.29.786-2.014-2.048-2.057-5.274-5.394-7.396-8.067-2.112-2.659-4.674-6.602-6.083-8.829a1.19 1.19 0 0 0-2.032.048c-1.313 2.315-3.708 6.448-5.642 9.303-1.895 2.797-4.737 6.418-6.513 8.633-.626.78-.043 1.946.957 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m172.187 56.709-18.883-21.236a1.16 1.16 0 0 0-1.791.071l-17.095 22.6A1.16 1.16 0 0 0 135.28 60l17.985.981q.106.007.213-.008l17.993-2.344a1.159 1.159 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M134.071 69.25c17.486 2.655 21.984 3.252 39.33-1.454a1.155 1.155 0 0 0 .479-1.966l-8.76-8.031-11.297-11.004a1.16 1.16 0 0 0-1.702.091l-9.736 11.774-8.952 8.606c-.693.667-.312 1.84.638 1.984"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M87.283 61.995a.773.773 0 0 0-.705-.74L83.647 61a.773.773 0 0 0-.84.8l.213 5.603c.016.427.375.76.801.743l2.918-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m71.153 38.363 25.923-.982c1.02-.039 1.507-1.29.786-2.014-2.049-2.057-5.274-5.394-7.397-8.066-2.112-2.66-4.674-6.603-6.082-8.83a1.188 1.188 0 0 0-2.032.048c-1.314 2.315-3.708 6.448-5.642 9.303-1.895 2.797-4.737 6.418-6.513 8.633-.626.78-.044 1.946.957 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M103.495 48.659 84.612 27.422a1.16 1.16 0 0 0-1.791.07l-17.095 22.6a1.16 1.16 0 0 0 .861 1.857l17.986.981q.106.006.213-.008l17.993-2.345a1.16 1.16 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M65.378 61.2c17.485 2.654 21.984 3.252 39.33-1.454a1.155 1.155 0 0 0 .479-1.966l-8.76-8.031L85.13 38.744a1.16 1.16 0 0 0-1.702.092L73.692 50.61l-8.953 8.606c-.693.666-.312 1.84.639 1.984"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M56.364 56.722a.773.773 0 0 0-.705-.74l-2.931-.255a.773.773 0 0 0-.84.8l.213 5.603a.773.773 0 0 0 .801.743l2.918-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m40.235 33.09 25.923-.983c1.02-.038 1.507-1.29.786-2.014-2.049-2.057-5.274-5.393-7.397-8.066-2.111-2.659-4.674-6.602-6.082-8.829a1.188 1.188 0 0 0-2.032.047c-1.313 2.315-3.708 6.449-5.642 9.303-1.895 2.798-4.737 6.42-6.513 8.634-.626.78-.044 1.945.956 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M72.577 43.385 53.694 22.15a1.16 1.16 0 0 0-1.791.071l-17.095 22.6a1.16 1.16 0 0 0 .861 1.856l17.986.982q.106.004.213-.008l17.993-2.345a1.16 1.16 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M34.46 55.927c17.485 2.654 21.984 3.252 39.33-1.455a1.155 1.155 0 0 0 .479-1.965l-8.76-8.032-11.297-11.004a1.16 1.16 0 0 0-1.702.092l-9.736 11.773-8.953 8.607c-.693.666-.312 1.84.639 1.983"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M101.316 37.537a.773.773 0 0 0-.706-.74l-1.569-.136a.773.773 0 0 0-.838.799l.128 3.4c.016.426.375.76.802.743l1.561-.06a.77.77 0 0 0 .743-.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "m90.863 20.85 16.434-.623c1.021-.039 1.507-1.294.791-2.022-1.404-1.429-3.277-3.403-4.566-5.026-1.32-1.662-2.893-4.044-3.91-5.636-.479-.75-1.597-.724-2.038.048-.95 1.659-2.419 4.164-3.629 5.95-1.155 1.706-2.817 3.853-4.042 5.395-.623.784-.04 1.951.96 1.913"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "M112.151 27.55 99.734 13.584a1.16 1.16 0 0 0-1.791.071L86.7 28.517a1.16 1.16 0 0 0 .862 1.857l11.826.645q.106.006.213-.008l11.833-1.542a1.16 1.16 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#24477e",
			d: "M86.762 36.883c11.39 1.725 14.719 2.081 26.058-.953a1.154 1.154 0 0 0 .482-1.963l-5.631-5.162-7.59-7.393a1.16 1.16 0 0 0-1.702.091l-6.534 7.902L86.13 34.9c-.693.666-.317 1.838.633 1.982"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M119.515 58.246a.773.773 0 0 0-.706-.74l-2.931-.255a.773.773 0 0 0-.839.8l.212 5.603a.773.773 0 0 0 .802.743l2.917-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m103.384 34.613 25.923-.982c1.021-.039 1.507-1.29.786-2.014-2.048-2.057-5.274-5.394-7.396-8.066-2.112-2.66-4.674-6.603-6.083-8.83a1.188 1.188 0 0 0-2.031.048c-1.314 2.315-3.709 6.448-5.643 9.303-1.895 2.797-4.737 6.419-6.513 8.633-.626.78-.043 1.946.957 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "m135.726 44.909-18.883-21.236a1.16 1.16 0 0 0-1.791.071l-17.095 22.6a1.16 1.16 0 0 0 .862 1.856l17.985.981q.106.007.213-.008l17.993-2.344a1.159 1.159 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#163b74",
			d: "M97.61 57.45c17.485 2.655 21.983 3.253 39.329-1.454a1.155 1.155 0 0 0 .479-1.965l-8.76-8.032-11.297-11.004a1.16 1.16 0 0 0-1.702.091l-9.736 11.774-8.952 8.607c-.693.666-.312 1.84.638 1.983"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M77.273 54.108a.773.773 0 0 0-.706-.74l-1.361-.119a.773.773 0 0 0-.839.8l.116 3.064c.016.427.375.76.802.743l1.355-.051a.773.773 0 0 0 .743-.801z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "m67.686 38.477 14.989-.567c1.02-.04 1.508-1.294.793-2.024-1.295-1.321-2.972-3.096-4.136-4.563-1.202-1.513-2.627-3.665-3.578-5.148-.48-.75-1.599-.724-2.041.047-.887 1.548-2.22 3.813-3.321 5.44-1.046 1.543-2.536 3.473-3.668 4.902-.621.784-.038 1.951.962 1.913"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "M87.29 44.63 75.856 31.773a1.16 1.16 0 0 0-1.791.07l-10.35 13.683a1.16 1.16 0 0 0 .861 1.857l10.888.594q.107.006.213-.008l10.895-1.42a1.16 1.16 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e2e8f3",
			d: "M63.837 53.475c10.467 1.584 13.613 1.904 24.041-.877a1.152 1.152 0 0 0 .48-1.962l-5.153-4.725-7.026-6.844a1.16 1.16 0 0 0-1.702.092l-6.046 7.312-5.224 5.022c-.693.666-.32 1.838.63 1.982"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M146.329 66.605a.773.773 0 0 0-.705-.741l-2.932-.254a.773.773 0 0 0-.839.799l.213 5.604a.773.773 0 0 0 .801.743l2.918-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m130.198 42.972 25.923-.982c1.021-.039 1.507-1.29.787-2.014-2.049-2.057-5.274-5.394-7.397-8.066-2.112-2.66-4.674-6.603-6.082-8.83a1.19 1.19 0 0 0-2.032.048c-1.314 2.315-3.708 6.448-5.642 9.303-1.895 2.797-4.738 6.418-6.513 8.633-.626.78-.044 1.946.956 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m162.541 53.268-18.884-21.236a1.158 1.158 0 0 0-1.79.071l-17.095 22.6a1.16 1.16 0 0 0 .861 1.856l17.986.981q.107.007.213-.008l17.992-2.344a1.16 1.16 0 0 0 .717-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M124.424 65.81c17.485 2.654 21.984 3.251 39.33-1.455a1.155 1.155 0 0 0 .479-1.966l-8.761-8.031-11.296-11.004a1.16 1.16 0 0 0-1.702.091l-9.736 11.774-8.953 8.607c-.693.666-.312 1.839.639 1.983"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M218.046 82.757a.773.773 0 0 0-.705-.74l-2.932-.255a.773.773 0 0 0-.839.8l.213 5.603c.016.426.375.76.801.743l2.917-.11a.77.77 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m201.916 59.125 25.923-.982c1.021-.04 1.507-1.29.786-2.014-2.048-2.057-5.273-5.394-7.396-8.067-2.112-2.659-4.674-6.602-6.083-8.829a1.188 1.188 0 0 0-2.031.048c-1.314 2.315-3.709 6.448-5.643 9.303-1.895 2.797-4.737 6.418-6.512 8.633-.627.78-.044 1.946.956 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m234.259 69.42-18.884-21.235a1.158 1.158 0 0 0-1.79.07l-17.095 22.6a1.159 1.159 0 0 0 .861 1.856l17.985.982q.107.006.213-.008l17.993-2.345a1.16 1.16 0 0 0 .717-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M196.14 81.962c17.486 2.654 21.985 3.252 39.331-1.454a1.155 1.155 0 0 0 .478-1.966l-8.76-8.032-11.297-11.004a1.16 1.16 0 0 0-1.702.092l-9.736 11.774-8.952 8.606c-.693.666-.312 1.84.638 1.984"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M102.54 60.834a.773.773 0 0 0-.705-.74l-2.932-.255a.773.773 0 0 0-.839.799l.213 5.604a.773.773 0 0 0 .801.743l2.918-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m86.41 37.2 25.922-.981c1.021-.039 1.507-1.29.787-2.014-2.049-2.057-5.274-5.394-7.397-8.066-2.112-2.66-4.674-6.603-6.082-8.83a1.188 1.188 0 0 0-2.032.048c-1.314 2.315-3.709 6.448-5.642 9.303-1.895 2.797-4.738 6.418-6.513 8.633-.626.78-.044 1.946.956 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M118.753 47.496 99.869 26.261a1.16 1.16 0 0 0-1.79.07l-17.095 22.6a1.16 1.16 0 0 0 .861 1.857l17.986.98q.106.007.212-.007l17.993-2.345a1.16 1.16 0 0 0 .717-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M80.636 60.038c17.485 2.655 21.984 3.253 39.33-1.454a1.155 1.155 0 0 0 .478-1.966l-8.76-8.031-11.296-11.004a1.16 1.16 0 0 0-1.703.091L88.95 49.448l-8.952 8.607c-.693.666-.312 1.839.638 1.983"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M236.284 71.83a.77.77 0 0 0-.705-.74l-2.932-.255a.772.772 0 0 0-.838.8l.212 5.603c.016.427.375.76.801.743l2.918-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m220.153 48.197 25.924-.982c1.02-.039 1.507-1.29.786-2.014-2.049-2.057-5.274-5.394-7.397-8.066-2.112-2.66-4.674-6.603-6.082-8.83a1.19 1.19 0 0 0-2.032.048c-1.314 2.315-3.708 6.448-5.642 9.303-1.895 2.797-4.737 6.419-6.513 8.633-.626.78-.044 1.946.956 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "m252.496 58.493-18.884-21.236a1.158 1.158 0 0 0-1.79.071l-17.095 22.6a1.16 1.16 0 0 0 .861 1.856l17.986.982q.106.004.213-.008l17.993-2.345a1.16 1.16 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#b5c3dc",
			d: "M214.379 71.034c17.485 2.655 21.984 3.253 39.33-1.454a1.155 1.155 0 0 0 .479-1.965l-8.761-8.032-11.296-11.004a1.16 1.16 0 0 0-1.702.091l-9.736 11.774-8.953 8.607c-.693.666-.312 1.84.639 1.983"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M36.826 52.789a.773.773 0 0 0-.706-.74l-1.837-.16a.773.773 0 0 0-.839.8l.145 3.834a.774.774 0 0 0 .802.743l1.829-.07a.773.773 0 0 0 .743-.801z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m25.254 34.731 18.304-.693c1.021-.039 1.508-1.292.79-2.02-1.54-1.561-3.672-3.799-5.123-5.626-1.474-1.856-3.238-4.538-4.338-6.264-.478-.75-1.596-.726-2.037.047-1.026 1.797-2.675 4.617-4.026 6.611-1.299 1.918-3.187 4.349-4.529 6.033-.623.783-.04 1.95.96 1.912"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M48.722 42.14 35.03 26.743a1.16 1.16 0 0 0-1.79.07L20.843 43.2a1.16 1.16 0 0 0 .861 1.856l13.04.712q.108.006.214-.008l13.046-1.7a1.16 1.16 0 0 0 .717-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M20.825 52.106c12.588 1.908 16.15 2.31 28.67-1.051a1.155 1.155 0 0 0 .483-1.965l-6.247-5.727-8.32-8.105a1.16 1.16 0 0 0-1.703.091l-7.165 8.665-6.354 6.109c-.693.666-.314 1.839.636 1.983"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M195.432 86.388a.773.773 0 0 0-.706-.74l-2.931-.255a.773.773 0 0 0-.839.8l.212 5.603a.773.773 0 0 0 .802.743l2.917-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m179.301 62.755 25.923-.982c1.021-.039 1.507-1.29.786-2.014-2.048-2.057-5.274-5.394-7.396-8.066-2.112-2.66-4.674-6.603-6.083-8.83a1.188 1.188 0 0 0-2.031.048c-1.314 2.315-3.709 6.448-5.643 9.303-1.895 2.797-4.737 6.419-6.513 8.633-.626.78-.043 1.946.957 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M211.643 73.05 192.76 51.816a1.16 1.16 0 0 0-1.791.07l-17.095 22.6a1.16 1.16 0 0 0 .862 1.857l17.985.981q.106.006.213-.008l17.993-2.345a1.159 1.159 0 0 0 .716-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M173.526 85.593c17.486 2.654 21.984 3.252 39.33-1.455a1.155 1.155 0 0 0 .479-1.965l-8.76-8.032-11.297-11.004a1.16 1.16 0 0 0-1.702.091l-9.736 11.774-8.952 8.607c-.693.666-.312 1.84.638 1.984"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6b5757",
			d: "M171.664 74.847a.773.773 0 0 0-.705-.74l-2.932-.255a.773.773 0 0 0-.839.8l.213 5.603a.773.773 0 0 0 .801.743l2.918-.11a.773.773 0 0 0 .743-.802z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m155.533 51.214 25.923-.982c1.021-.039 1.507-1.29.787-2.014-2.049-2.057-5.274-5.394-7.397-8.066-2.112-2.66-4.674-6.603-6.082-8.83a1.19 1.19 0 0 0-2.032.048c-1.314 2.315-3.708 6.448-5.642 9.303-1.895 2.797-4.738 6.419-6.513 8.633-.626.78-.044 1.946.956 1.908"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "m187.876 61.51-18.884-21.236a1.158 1.158 0 0 0-1.79.07l-17.095 22.6a1.16 1.16 0 0 0 .861 1.857l17.986.981q.107.006.212-.008l17.993-2.345a1.16 1.16 0 0 0 .717-1.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#dae2f1",
			d: "M149.759 74.052c17.485 2.654 21.984 3.252 39.33-1.455a1.155 1.155 0 0 0 .479-1.965l-8.761-8.032-11.296-11.004a1.16 1.16 0 0 0-1.703.092l-9.735 11.773-8.953 8.607c-.693.666-.312 1.84.639 1.984"
		})
	]
});
export default SvgForestLeft;
